// src/Component/hooks/useUpdateJenis_beban.jsx
import { useState } from 'react';
import api from '../Services/api';
import endpoints from '../Services/endpointAdmin';

/**
 * usePutJenisBeban adalah custom hook yang digunakan untuk memperbarui data jenis beban di backend.
 * @returns { Object } - Mengembalikan fungsi putJenisBeban, serta status loading dan error.
 */
const usePutJenisBeban = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Fungsi untuk memperbarui data jenis beban di backend.
   * @param { number } id - ID jenis beban yang akan diperbarui.
   * @param { string } nama_beban
   * @returns { Promise<Object> } - Mengembalikan data respons dari backend atau error.
   */
  const putJenisBeban = async (id, nama_beban) => {
    setLoading(true);
    setError(null);

    try {
      const data = {
        nama_beban,
      };

      if (!endpoints.jenis_beban || typeof endpoints.jenis_beban.update !== 'function') {
        throw new Error('endpoints.jenis_beban.update is not defined');
      }

      const response = await api.put(endpoints.jenis_beban.update(id), data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (err) {
      console.error('Error updating jenis beban:', err);
      setError(
        err.response?.data?.error ||
        err.response?.data?.message ||
        err.message ||
        'Terjadi kesalahan saat memperbarui jenis beban.'
      );
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { putJenisBeban, loading, error };
};

export default usePutJenisBeban;
